"use strict";

exports.__esModule = true;
exports.RoleListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of role to consumers.
 * @component
 */
var RoleListContext = exports.RoleListContext = (0, _Utils.createEnhancedContext)({
  propName: "roles"
});